import classNames from "classnames";
import React from "react";
import { ShareableLinkInfoModal } from ".";
import { ExternalLink } from "../ui";
import { PasteInput, PasteInputProps } from "./Form";
import { SvgSprite } from "./SvgSprite";

interface ShareablePasteInputProps
  extends Pick<
    PasteInputProps,
    | "value"
    | "touched"
    | "error"
    | "field"
    | "onPaste"
    | "customValidationError"
  > {
  application: "AU" | "NZ" | "NSW";
}

export const ShareablePasteInput = ({
  application,
  ...rest
}: ShareablePasteInputProps) => {
  const [showShareableModal, setShowShareableModal] =
    React.useState<boolean>(false);

  const handleToggleShareableModal = () => {
    setShowShareableModal((prev) => !prev);
  };

  const handleCloseShareableModal = () => {
    setShowShareableModal(false);
  };

  const isNsw = application === "NSW";
  const baseUrl =
    application === "NZ" ? "https://www.seek.co.nz" : "https://www.seek.com.au";
  const seekProfileUrl = `${baseUrl}/profile/me`;
  const profileVisibilityUrl = `${baseUrl}/profile-privacy`;

  return (
    <>
      <PasteInput
        id="shareableLink"
        className={isNsw ? "nsw-form__group" : undefined}
        label={
          <>
            SEEK Profile link <small className="text-muted">(optional)</small>
            <button
              type="button"
              title="What is a shareable link"
              className={
                isNsw
                  ? "d-inline-flex btn btn-link p-1 my-n1"
                  : "btn btn-link py-0 px-1"
              }
              onClick={handleToggleShareableModal}
            >
              <SvgSprite
                id="icons:question-circle"
                width={16}
                height={16}
                className="align-text-top"
              />
            </button>
          </>
        }
        labelProps={isNsw ? { className: "nsw-form__label mb-0" } : undefined}
        helpText={
          <>
            Share your skills, experience and qualifications using your SEEK
            Profile
            <ExternalLink href={seekProfileUrl} className="ml-2">
              Get link
            </ExternalLink>
          </>
        }
        helpTextProps={{
          className: isNsw
            ? "nsw-form__helper"
            : "form-text text-muted mt-n1 mb-1",
        }}
        inputWrapperProps={{
          className: isNsw
            ? "d-flex flex-nowrap gap-3"
            : classNames("input-group gap-3", {
                "is-invalid": !!(rest.error && rest.touched),
                "mb-3": !(rest.error && rest.touched),
              }),
        }}
        inputProps={{
          className: isNsw ? "nsw-form__input" : "form-control rounded",
        }}
        buttonProps={{
          className: isNsw
            ? "flex-shrink-0 btn btn-outline-primary px-3"
            : "btn btn-outline-secondary rounded",
        }}
        {...rest}
      />
      <ShareableLinkInfoModal
        show={showShareableModal}
        onHide={handleCloseShareableModal}
        seekProfileUrl={seekProfileUrl}
        profileVisibilityUrl={profileVisibilityUrl}
      />
    </>
  );
};
